import { render } from "./ReportIssue.vue?vue&type=template&id=5484d6e0&scoped=true"
import script from "./ReportIssue.vue?vue&type=script&lang=js"
export * from "./ReportIssue.vue?vue&type=script&lang=js"

import "./ReportIssue.vue?vue&type=style&index=0&id=5484d6e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5484d6e0"]])

export default __exports__